var angular = require('angular');
var _module = angular.module('benoit');
var config = require('config');
var _ = require('lodash');

_module.factory('$themes', [
    '$log',
    '$http',
    '$timeout',

    function themes($log, $http, $timeout) {
        var THEMES_URL = config.themesUrl;

        function Themes() {
            this.currentTheme = undefined;
            this.loading = true;
            this.loadingError = undefined;
            this.themes = undefined;

            // Fetch and store the themes
            this._fetchThemes()
            .catch((function onFetchError(err) {
                $log.error('Themes -> _fetchThemes -> Error', err);
                this.loadingError = err;
            }).bind(this))
            .finally((function () {
                this.loading = false;
            }).bind(this));
        }


        ////////////////////////////////////////////////////////
        // Private Functions
        ////////////////////////////////////////////////////////

        /*
        @private
        @function _fetchThemes
        */
        Themes.prototype._fetchThemes = function _fetchThemes() {
            return $http.get(THEMES_URL)
            .then((function onFetchSuccess(response) {
                this.themes = [].concat.apply([], _.values(response.data));

                $log.debug('Themes', this.themes);
            }).bind(this));
        };

        /*
        @private
        @function _buildStyles
        @param {Object} theme
        */
        Themes.prototype._buildStyles = function _buildStyles(theme) {
            var css = '';

            theme.palette.forEach(function (color, index) {
                css += '.theme-background-color-' + index + ' { background-color:' + color + ' !important; background-image: none !important; } ';
                css += '.theme-background-hover-color-' + index + ':hover { background-color:' + color + ' !important; background-image: none !important; } ';

                css += '.theme-btn-background-color-' + index + ' { background-color:' + color + ' !important; } ';
                css += '.theme-btn-background-color-' + index + ':hover { opacity: 0.75 } ';
                css += '.theme-btn-background-hover-color-' + index + ':hover { opacity: 1; background-color:' + color + ' !important; } ';

                css += '.theme-text-color-' + index + ' { color:' + color + ' !important; } ';
                css += '.theme-text-hover-color-' + index + ':hover { color:' + color + ' !important; } ';

                css += '.theme-border-color-' + index + ' { border-color:' + color + ' !important; } ';
                css += '.theme-border-hover-color-' + index + ':hover { border-color:' + color + ' !important; } ';

                css += '.theme-element-hover-a-text-color-' + index + ':hover a { color:' + color + ' !important; } ';

                css += '.theme-element-a-hover-background-color-' + index + ' a:hover { background-color:' + color + ' !important; } ';
            });

            return css;
        };

        /*
        @private
        @function _addStylesToHeader
        @param {String} themeId
        @param {String} css
        */
        Themes.prototype._addStyleToHeader = function _addStyleToHeader(themeId, css) {
            var head = document.head || document.getElementsByTagName('head')[0];
            var style = document.createElement('style');
            style.type = 'text/css';
            style.id = themeId;

            if (style.styleSheet){
                style.styleSheet.cssText = css;
            } else {
                style.appendChild(document.createTextNode(css));
            }

            head.appendChild(style);
        };


        ////////////////////////////////////////////////////////
        // Public Functions
        ////////////////////////////////////////////////////////

        /*
        @function setTheme
        @param {String} themeId
        */
        Themes.prototype.setTheme = function setTheme(themeId) {
            if(this._setThemeTimeout) $timeout.cancel(this._setThemeTimeout);

            if(this.currentTheme) {
                angular.element(document.getElementById(this.currentTheme.id)).remove();
                this.currentTheme = undefined;
            }

            if(this.loading) {
                this._setThemeTimeout = $timeout(this.setTheme.bind(this), 100, true, themeId);
                return;
            }

            var theme = this.currentTheme = _.find(this.themes, { id: themeId });

            if(theme) {
                var css = this._buildStyles(theme);
                this._addStyleToHeader(themeId, css);
            } else {
                $log.error(new Error(['Theme `', themeId, '` not found'].join('')));
            }
        };

        return new Themes();
    }
]);
